// extracted by mini-css-extract-plugin
export default {"pillar":"AlpsWords_pillar__rj9q2","initial":"AlpsWords_initial__5lWjM"};